import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { SuperAdminDashboardStats } from "../@types";

interface CompanyStatusChartProps {
  data: SuperAdminDashboardStats;
}

const CompanyStatusChart: React.FC<CompanyStatusChartProps> = ({ data }) => {
  const chartData = [
    {
      name: "Active companies",
      value: data.totalActiveCompanies,
      color: "#0891b2",
    },
    {
      name: "Inactive companies",
      value: data.totalInActiveCompanies,
      color: "#d1d5db",
    },
  ];

  const totalCompanies =
    data.totalActiveCompanies + data.totalInActiveCompanies;

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const percentage = ((payload[0].value / totalCompanies) * 100).toFixed(1);
      return (
        <div className="bg-white p-3 border border-gray-200 rounded shadow-lg">
          <p className="font-semibold text-gray-800 mb-1">{payload[0].name}</p>
          <p className="text-sm text-gray-600">
            {payload[0].value} companies ({percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const renderCustomLabel = () => {
    return (
      <g>
        <text
          x="50%"
          y="45%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-4xl font-bold fill-gray-900"
        >
          {totalCompanies}
        </text>
        <text
          x="50%"
          y="55%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-sm fill-gray-500"
        >
          Total
        </text>
      </g>
    );
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">
        Companies status overview
      </h3>

      <div className="mx-auto flex w-full max-w-[280px] items-center justify-center">
        <ResponsiveContainer width="100%" height={280}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              startAngle={90}
              endAngle={450}
              dataKey="value"
              stroke="none"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            {renderCustomLabel()}
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 bg-[#0891b2] rounded-sm" />
          <div>
            <p className="text-2xl font-bold text-gray-900">
              {data.totalActiveCompanies}
            </p>
            <p className="text-sm text-gray-600">Active companies</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 bg-gray-300 rounded-sm" />
          <div>
            <p className="text-2xl font-bold text-gray-900">
              {data.totalInActiveCompanies}
            </p>
            <p className="text-sm text-gray-600">Inactive companies</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyStatusChart;
